import { CustomSelect, Props as CustomSelectProps } from '../CustomSelect/CustomSelect'
import * as Styled from './styles'

type Props = {
  name: string
} & CustomSelectProps

export const SelectInput = (props: Props) => {
  const { name, ...selectProps } = props

  return (
    <Styled.Container>
      <Styled.NameContainer>
        <Styled.NameText $isDisabled={props.disabled}>{name}</Styled.NameText>
      </Styled.NameContainer>
      <Styled.SelectContainer>
        <CustomSelect {...selectProps} />
      </Styled.SelectContainer>
    </Styled.Container>
  )
}
